import { FilterField, Position } from 'coreOld/enums';

export const filtersConfig = [
  {
    name: 'query',
    type: FilterField.SEARCH,
    flex: 60,
    minWidth: 280,
    border: Position.LEFT,
    paddingLeft: 24,
    paddingRight: 24,
  },
];
